import { render, staticRenderFns } from "./recaptcha-v2.vue?vue&type=template&id=11bfbb51&"
import script from "./recaptcha-v2.vue?vue&type=script&lang=js&"
export * from "./recaptcha-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports